<div class="container-fluid facturas-page">
  <div class="card shadow-lg">
    <div
      class="card-header d-flex justify-content-between align-items-center header-cave"
    >
      <h2 class="mb-0">Facturas</h2>
      <button class="btn btn-cave" (click)="volver()">
        <fa-icon [icon]="icoRet"></fa-icon> Volver
      </button>
    </div>

    <div class="card-body">
      <div
        *ngIf="resul"
        class="spinner-border text-primary d-block mx-auto"
        role="status"
      ></div>

      <!-- Tabla para escritorio -->
      <div class="table-responsive mt-3 d-none d-md-block">
        <table
          datatable
          [dtOptions]="dtOptions"
          [dtTrigger]="dtTrigger"
          id="tabla"
          class="table table-hover align-middle table-cave"
        >
          <thead>
            <tr>
              <th>Fecha</th>
              <th>Serie</th>
              <th>Factura</th>
              <th>Doc.Asociado</th>
              <th>Fec.Asociado</th>
              <th>Ventas</th>
              <th>I.V.A.</th>
              <th>Total Neto</th>
              <th>Docum.</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dato of datosTabla; index as i">
              <td [ngClass]="{ stotal: dato.facFech === 'TOTALES' }">
                {{ dato.facFech }}
              </td>
              <td>{{ dato.facSeri }}</td>
              <td
                *ngIf="dato.facNume > 0"
                [ngClass]="{ stotal: dato.facFech === 'TOTALES' }"
                class="numero"
              >
                {{ dato.facNume }}
              </td>
              <td *ngIf="dato.facNume === 0"></td>
              <td>{{ dato.facDocu }}</td>
              <td>{{ dato.facFdoc }}</td>
              <td
                [ngClass]="{ stotal: dato.facFech === 'TOTALES' }"
                class="numero"
              >
                {{ dato.facVtas | number: ".2" }}
              </td>
              <td
                [ngClass]="{ stotal: dato.facFech === 'TOTALES' }"
                class="numero"
              >
                {{ dato.facIvas | number: ".2" }}
              </td>
              <td
                [ngClass]="{ stotal: dato.facFech === 'TOTALES' }"
                class="numero"
              >
                {{ dato.facNeto | number: ".2" }}
              </td>
              <td *ngIf="dato.facFech === 'TOTALES' || dato.facNume < 1">--</td>
              <td *ngIf="dato.facFech !== 'TOTALES' && dato.facNume > 0">
                <button class="btn-cave" (click)="documento(i)">
                  Descargar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="separador"></div>
      <!--
      <div class="container">
        <div class="header-section">
          <h1>Facturas</h1>
          <hr />
        </div>

        <div class="action-bar">
          <button class="btn-back" (click)="volver()">
            <fa-icon [icon]="icoRet"></fa-icon> Volver
          </button>
        </div>

        <div class="loading" *ngIf="resul">
          <div class="spinner"></div>
        </div>

 
        <div class="table-container">
          <table
            datatable
            [dtOptions]="dtOptions"
            [dtTrigger]="dtTrigger"
            id="tabla"
            class="data-table"
          >
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Serie</th>
                <th>Factura</th>
                <th>Doc.Asociado</th>
                <th>Fec.Asociado</th>
                <th>Ventas</th>
                <th>I.V.A.</th>
                <th>Total Neto</th>
                <th>Docum.</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let dato of datosTabla; index as i">
                <td>{{ dato.facFech }}</td>
                <td>{{ dato.facSeri }}</td>
                <td>{{ dato.facNume }}</td>
                <td>{{ dato.facDocu }}</td>
                <td>{{ dato.facFdoc }}</td>
                <td class="number">{{ dato.facVtas | number : ".2" }}</td>
                <td class="number">{{ dato.facIvas | number : ".2" }}</td>
                <td class="number">{{ dato.facNeto | number : ".2" }}</td>
                <td>
                  <button class="btn-cave" (click)="documento(i)">
                    Descargar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
-->

      <!-- Mobile Cards -->
      <div class="mobile-cards">
        <div *ngFor="let dato of datosTabla; index as i" class="card-item">
          <div
            class="card-header"
            (click)="
              expandedIndex === i ? (expandedIndex = null) : (expandedIndex = i)
            "
          >
            <div><strong>Fecha:</strong> {{ dato.facFech }}</div>
            <div><strong>Serie:</strong> {{ dato.facSeri }}</div>
            <div><strong>Factura:</strong> {{ dato.facNume }}</div>
            <div class="expand-hint">Toca para ver más...</div>
          </div>

          <div *ngIf="expandedIndex === i" class="card-details">
            <div class="detail-row">
              <span>Doc. Asociado:</span> {{ dato.facDocu }}
            </div>
            <div class="detail-row">
              <span>Fecha Asociado:</span> {{ dato.facFdoc }}
            </div>
            <div class="detail-row">
              <span>Ventas:</span> {{ dato.facVtas | number: ".2" }}
            </div>
            <div class="detail-row">
              <span>I.V.A.:</span> {{ dato.facIvas | number: ".2" }}
            </div>
            <div class="detail-row">
              <span>Total Neto:</span> {{ dato.facNeto | number: ".2" }}
            </div>

            <div
              class="detail-row"
              style="justify-content: center; margin-top: 1rem"
            >
              <button class="btn-cave" (click)="documento(i)">Descargar</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
